// Generated types for PartDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLStructureReadAPI, SysMLStructureWriteAPI } from './sysmlstructure';
import { SysMLStructureReadAPISchemaObject, SysMLStructureWriteAPISchemaObject } from './sysmlstructure';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PartDefinitionReadAPI extends SysMLStructureReadAPI {
}

export interface PartDefinitionWriteAPI extends SysMLStructureWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PartDefinitionReadAPISchemaObject = SysMLStructureReadAPISchemaObject.extend({}).passthrough();
export const PartDefinitionReadAPISchema: z.ZodType<PartDefinitionReadAPI> = PartDefinitionReadAPISchemaObject;

export const PartDefinitionWriteAPISchemaObject = SysMLStructureWriteAPISchemaObject.extend({}).passthrough();
export const PartDefinitionWriteAPISchema: z.ZodType<PartDefinitionWriteAPI> = PartDefinitionWriteAPISchemaObject;
